const Renderer = require('../Renderer');
const LayerUtil = require('../../utils/LayerUtil');
const CommonUtil = require('../../utils/CommonUtil');
const g2 = require('../../g2');
const RestWMSService = require('../../adaptor/RestWMSService');
/**
 * @ignore
 * 要素渲染
 * @param {Object} options - 构造参数；
 * @param {G.Map} options.map - 地图对象
 * @param {String} options.id
 * @param {String} options.name
 * @param {String} options.idField
 * @param {Object} options.featureBuilder
 * @param {String} options.geometryType
 *
 * @example
 * //使用示例代码
 * //todo
 */
let renderer = Renderer.extend({
    options: {},
    initialize(options) {
        Renderer.prototype.initialize.call(this, options);
        this.options.geometryType = this.options.geometryType || 'point';
        const layerOptions = this.options.layerOptions;
        // console.log(layerOptions);
        const layerOpts = {
            id: layerOptions.id,
            name: layerOptions.name,
            tileType: layerOptions.tileType || 101,
            url: layerOptions.url,
            layers: layerOptions.layers,
            opacity: layerOptions.opacity || 1,
            visible: layerOptions.visible || true,
            projection: layerOptions.projection || this.options.map.spatialReference
        };
        // console.log(layerOpts);
        this.layer = new g2.carto.TileLayer(layerOpts);
        // console.log(this.layer);
        // var grouplayer = new g2.carto.GroupLayer({
        //     layers: [],
        // });
        // this.options.map.addLayer(grouplayer);
        // grouplayer.addLayer(this.layer);
        // this.options.map.addLayer(this.layer);
        // console.log(this.options.map);
        LayerUtil.addLayer2Group(this.options.map, this.layer, this.options.geometryType);

        // const deserializer = new g2.core.Deserializer();
        // const restHttp = new g2.core.RestHttp();
        // const url = options.layerOptions.url.split('/wms')[0];
        // // 初始化wms服务
        // let pkg = g2.ows || g2.ews;
        // this.service = new pkg.RestWMSService({
        //     url: url,
        //     http: restHttp,
        //     deserializer: deserializer
        // });

        this.service = new RestWMSService(options);

    },
    
    /**
     */
    destroy() {
        this.clear();
        Renderer.prototype.destroy.call(this);
    },
    /**
     *
     * @returns {*}
     */
    getLayer() {
        return this.layer;
    },
    /**
     *
     */
    getExtent() {
        return LayerUtil.getLayerExtent(this.layer);
    },
    /**
     */
    clear() {
        LayerUtil.removeLayerFromGroup(this.options.map, this.layer, this.options.geometryType);
    },
    
    /**
     */
    setVisible(visible) {
        this.layer.setVisible(!!visible);
    },
    
    /**
     */
    getVisible() {
        return this.layer.visible;
    },
    //
    hitTest(screenX, screenY) {
        return new Promise(async (resolve, reject) => {
            const map = this.options.map;
            // const layers = this.options.layerOptions.layers;
            // const featureCount = 50;
            const viewSize = map.getViewSize();
            // const extent = map.getExtent();
            // const width = viewSize[0];
            // const height = viewSize[1];
            // const x = Math.floor(screenX);
            // const y = Math.floor(screenY);
            // const srs = 'EPSG:' + map.spatialReference;
            // const format = 'application/json';
            // const buffer = 2;
            const options = {
                layers: this.options.layerOptions.layers,
                featureCount: 50,
                viewSize: map.getViewSize(),
                extent: map.getExtent(),
                width: viewSize[0],
                height: viewSize[1],
                x: Math.floor(screenX),
                y: Math.floor(screenY),
                srs: 'EPSG:' + map.spatialReference,
                format: 'application/json',
                buffe: 2,
            }
            const result = await this.service.getFeatureInfo(options);
            // const result = await this.service.getFeatureInfo(layers, [layers], featureCount, extent, width, height, x, y, srs, buffer, format);
            const list = [];
            
            try {
                // todo 兼容tsgis的结果
                if (result.featureInfos) {
                    let arr = result.featureInfos[0].entity.entities;
                    for (let i = 0 ;i < arr.length; i++) {
                        // todo
                    }
                } else if (result.features) {
                    let arr = result.features;
                    for (let i = 0 ;i < arr.length; i++) {
                        let element = this.options.featureBuilder.buildElementFromGeoJSON(arr [i]);
                        if (element) {
                            element.geometry.spatialReference = this.options.map.spatialReference;
                            list.push({element: element});
                        }
                    }
                } else if (result.entities) {
                    let arr = result.entities;
                    for (let i = 0 ;i < arr.length; i++) {
                        let element = this.options.featureBuilder.buildElementFromGFeature(arr[i]);
                        if (element) {
                            element.geometry.spatialReference = this.options.map.spatialReference;
                            list.push({element: element});
                        }
                    }
                }
            
            } catch(ex) {
                console.debug(ex);
            }
            resolve(list);
        });
    }
});

module.exports = renderer;